<div class="login-page-wrapper">
    <h1 class="main-heading">Vendor Registration</h1>

    <div class="form-container bg-white rounded-5 mb-3 shadow-lg">
        <app-progress-bar [currentStep]="currentTab" [steps]="steps" [withMargin]="false"></app-progress-bar>



        <!-- personal info form -->
        <form *ngIf="currentTab == 0" [formGroup]="_PersonalInfoForm" (ngSubmit)="onNext()">



            <!-- radio -->






            <!-- Reference Number Section (shown only when pre-filled via URL) -->
            <div class="mb-1 reference-number-section" *ngIf="isRegisteredInQNBN">
                <div class="general-reference d-flex align-items-center gap-2">
                    <label for="reference-number" class="reference-number-label form-label font-weight-bold mb-0">
                        Reference Number
                    </label>
                    <span class="form-control-plaintext fw-semibold">
                        {{ _PersonalInfoForm.get('VendorReference')?.value }}
                    </span>
                </div>
            </div>

            <!-- radio -->


            <div class="radio-container">
                <div class="radio-buttons-section d-flex align-items-center mb-2">
                    <label class="form-label fw-bold mb-0 me-2 radio-label">Sign in as :</label>
                    <div class="radio-general d-flex justify-content-between flex-grow-1 gap-2">
                        <!-- Individual -->
                        <div class="radio-buttons flex-fill px-2 py-2 border rounded-5">
                            <div class="radio-inside form-check">
                                <input class="radio-input form-check-input" type="radio" formControlName="vendorType"
                                    value="Individual" (change)="onSignInAsChange()">
                                <label class="form-check-label w-100 text-left">Individual</label>
                            </div>
                        </div>

                        <!-- Organization -->
                        <div class="radio-buttons flex-fill px-2 py-2 border rounded-5">
                            <div class="radio-inside form-check">
                                <input class="radio-input form-check-input" type="radio" formControlName="vendorType"
                                    value="Organization" (change)="onSignInAsChange()">
                                <label class="form-check-label w-100">Organization</label>
                            </div>
                        </div>

                        <!-- Investor -->
                        <!-- <div class="radio-buttons flex-fill px-2 py-2 border rounded-5">
                        <div class="radio-inside form-check">
                            <input class="radio-input form-check-input" type="radio" formControlName="vendorType"
                                value="Investor">
                            <label class="form-check-label w-100">Investor</label>
                        </div>
                    </div> -->
                    </div>
                </div>

                <div class="radio-buttons-section d-flex align-items-center mb-2">
                    <label class="form-label fw-bold mb-0 me-2 radio-label">Are You :</label>
                    <div class="radio-general d-flex justify-content-between flex-grow-1 gap-2">
                        <!-- Local -->
                        <div class="radio-buttons flex-fill px-2 py-2 border rounded-5">
                            <div class="radio-inside form-check">
                                <input class="radio-input form-check-input me-2" type="radio"
                                    formControlName="LocalOrForeign" value="local" (change)="onLocalOrForeignChange()">
                                <label class="form-check-label w-100">Local</label>
                            </div>
                        </div>

                        <!-- Foreign -->
                        <div class="radio-buttons flex-fill px-2 py-2 border rounded-5">
                            <div class="radio-inside form-check">
                                <input class="radio-input form-check-input me-2" type="radio"
                                    formControlName="LocalOrForeign" value="foreign" (change)="onLocalOrForeignChange()">
                                <label class="form-check-label w-100">Foreign</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="mb-1 email-section">
                <label for="email" class="email-label form-label font-weight-bold"
                    appRequiredField="Email">Email</label>
                <input type="email" class="email-inpute form-control rounded-4 bg-light" id="email"
                    formControlName="Email" placeholder="Enter your email">
                <div *ngIf="_PersonalInfoForm.get('Email')?.invalid && (_PersonalInfoForm.get('Email')?.dirty || _PersonalInfoForm.get('Email')?.touched)"
                    class="text-danger">

                    <small *ngIf="_PersonalInfoForm.get('Email')?.errors?.['custom']">{{
                        _PersonalInfoForm.get('Email')?.errors?.['custom'] }}</small>
                </div>
            </div>
            <div class="mb-1 password-section">
                <label for="password" class="password-label form-label" appRequiredField="password">Password</label>
                <input type="password" class="password-inpute form-control rounded-4 bg-light" id="password"
                    formControlName="password" placeholder="Enter your password">
                <div *ngIf="_PersonalInfoForm.get('password')?.invalid && (_PersonalInfoForm.get('password')?.dirty || _PersonalInfoForm.get('password')?.touched)"
                    class="text-danger">
                    <small *ngIf="_PersonalInfoForm.get('password')?.errors?.['custom']">{{
                        _PersonalInfoForm.get('password')?.errors?.['custom'] }}</small>
                </div>
            </div>
            <div class="mb-1 password-section">
                <label for="confirmPassword" class="password-label form-label">Confirm Password</label>
                <input type="password" class="password-inpute form-control rounded-4 bg-light" id="confirmPassword"
                    formControlName="confirmPassword" placeholder="Enter your Confirm password">
                <div *ngIf="_PersonalInfoForm.get('confirmPassword')?.invalid && (_PersonalInfoForm.get('confirmPassword')?.dirty || _PersonalInfoForm.get('confirmPassword')?.touched)"
                    class="text-danger">
                    <small *ngIf="_PersonalInfoForm.get('confirmPassword')?.errors?.['custom']">{{
                        _PersonalInfoForm.get('confirmPassword')?.errors?.['custom'] }}</small>
                </div>
            </div>


            <div class="submition d-flex justify-content-center mt-2">
                <button type="submit" class="submit-btn btn btn-primary" [disabled]="!ShowRegisterBtn">Next</button>
            </div>

            <div class="create-acc mt-1 d-flex justify-content-center ">
                <span class="dont-have-account">Have Account?&nbsp;</span>
                <a [routerLink]="['/', AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]"
                    class="create-account-link"> Sign in</a>
            </div>
        </form>
        <!-- Account info form -->
        <form [formGroup]="accountInfoForm" *ngIf="currentTab == 1" (ngSubmit)="onSubmitForm($event)">

            <div *ngIf="isOrganization">
                <div class="mb-1 single-point-of-contract-section">
                    <label for="single-point-of-contract"
                        class="single-point-of-contract-label form-label font-weight-bold"
                        appRequiredField="singlePointOfContact">Single point of contact</label>
                    <input type="text" class="single-point-of-contract-input form-control rounded-4 bg-light"
                        id="single-point-of-contract" formControlName="singlePointOfContact"
                        placeholder="Enter your Single point of contact">
                    <div *ngIf="accountInfoForm.get('singlePointOfContact')?.invalid && (accountInfoForm.get('singlePointOfContact')?.dirty || accountInfoForm.get('singlePointOfContact')?.touched)"
                        class="text-danger">
                        <small *ngIf="accountInfoForm.get('singlePointOfContact')?.errors?.['required']">This field is
                            required</small>
                        <small *ngIf="accountInfoForm.get('singlePointOfContact')?.errors?.['custom']">{{
                            accountInfoForm.get('singlePointOfContact')?.errors?.['custom'] }}</small>
                    </div>
                </div>
                <div class="mb-3 company-name-section">
                    <label for="company-name" class="company-name-label form-label"
                        appRequiredField="VendorName">Company
                        Name</label>
                    <input type="text" class="company-name-input form-control rounded-4 bg-light" id="company-name"
                        formControlName="VendorName" placeholder="Enter your Company Name">
                    <div *ngIf="accountInfoForm.get('VendorName')?.invalid && (accountInfoForm.get('VendorName')?.dirty || accountInfoForm.get('VendorName')?.touched)"
                        class="text-danger">
                        <small *ngIf="accountInfoForm.get('VendorName')?.errors?.['required']">This field is
                            required</small>
                        <small *ngIf="accountInfoForm.get('VendorName')?.errors?.['custom']">{{
                            accountInfoForm.get('VendorName')?.errors?.['custom'] }}</small>
                    </div>
                </div>
            </div>

            <div *ngIf="!isOrganization">
                <div class="mb-1 first-name-section">
                    <label for="first-name" class="first-name-label form-label font-weight-bold"
                        appRequiredField="firstName">First Name</label>
                    <input type="text" class="first-name-input form-control rounded-4 bg-light" id="first-name"
                        formControlName="firstName" placeholder="Enter your first name">
                    <div *ngIf="accountInfoForm.get('firstName')?.invalid && (accountInfoForm.get('firstName')?.dirty || accountInfoForm.get('firstName')?.touched)"
                        class="text-danger">
                        <small *ngIf="accountInfoForm.get('firstName')?.errors?.['required']">This field is
                            required</small>
                        <small *ngIf="accountInfoForm.get('firstName')?.errors?.['custom']">{{
                            accountInfoForm.get('firstName')?.errors?.['custom'] }}</small>
                    </div>
                </div>
                <div class="mb-3 last-name-section">
                    <label for="last-name" class="last-name-label form-label" appRequiredField="lastName">Last
                        Name</label>
                    <input type="text" class="last-name-input form-control rounded-4 bg-light" id="last-name"
                        formControlName="lastName" placeholder="Enter your last name">
                    <div *ngIf="accountInfoForm.get('lastName')?.invalid && (accountInfoForm.get('lastName')?.dirty || accountInfoForm.get('lastName')?.touched)"
                        class="text-danger">
                        <small *ngIf="accountInfoForm.get('lastName')?.errors?.['required']">This field is
                            required</small>
                        <small *ngIf="accountInfoForm.get('lastName')?.errors?.['custom']">{{
                            accountInfoForm.get('lastName')?.errors?.['custom'] }}</small>
                    </div>
                </div>
            </div>

            <!-- QATID - Show when Individual + Local -->
            <div class="mb-3 qatid-section" *ngIf="isLocal && !isOrganization">
                <label for="qatid" class="qatid-label form-label" appRequiredField="qatid">QATID</label>
                <input type="text" class="qatid-input form-control rounded-4 bg-light" id="qatid"
                    formControlName="qatid" placeholder="Enter your QATID">
                <div *ngIf="accountInfoForm.get('qatid')?.invalid && (accountInfoForm.get('qatid')?.dirty || accountInfoForm.get('qatid')?.touched)"
                    class="text-danger">
                    <small *ngIf="accountInfoForm.get('qatid')?.errors?.['required']">This field is required</small>
                    <small *ngIf="accountInfoForm.get('qatid')?.errors?.['custom']">{{
                        accountInfoForm.get('qatid')?.errors?.['custom'] }}</small>
                </div>
            </div>

            <!-- CR Number - Show when Organization + Local -->
            <div class="mb-3 cr-number-section" *ngIf="isLocal && isOrganization">
                <label for="cr-number" class="cr-number-label form-label" appRequiredField="crNumber">CR Number</label>
                <input type="text" class="cr-number-input form-control rounded-4 bg-light" id="cr-number"
                    formControlName="crNumber" placeholder="Enter your CR Number">
                <div *ngIf="accountInfoForm.get('crNumber')?.invalid && (accountInfoForm.get('crNumber')?.dirty || accountInfoForm.get('crNumber')?.touched)"
                    class="text-danger">
                    <small *ngIf="accountInfoForm.get('crNumber')?.errors?.['required']">This field is required</small>
                    <small *ngIf="accountInfoForm.get('crNumber')?.errors?.['custom']">{{
                        accountInfoForm.get('crNumber')?.errors?.['custom'] }}</small>
                </div>
            </div>

            <!-- Passport - Show when Individual + Foreign -->
            <div class="mb-3 passport-section" *ngIf="!isLocal && !isOrganization">
                <label for="passport" class="passport-label form-label" appRequiredField="passport">Passport</label>
                <input type="text" class="passport-input form-control rounded-4 bg-light" id="passport"
                    formControlName="passport" placeholder="Enter your Passport Number">
                <div *ngIf="accountInfoForm.get('passport')?.invalid && (accountInfoForm.get('passport')?.dirty || accountInfoForm.get('passport')?.touched)"
                    class="text-danger">
                    <small *ngIf="accountInfoForm.get('passport')?.errors?.['required']">This field is required</small>
                    <small *ngIf="accountInfoForm.get('passport')?.errors?.['custom']">{{
                        accountInfoForm.get('passport')?.errors?.['custom'] }}</small>
                </div>
            </div>

            <!-- Commercial Registration Number - Show when Organization + Foreign -->
            <div class="mb-3 commercial-registration-section" *ngIf="!isLocal && isOrganization">
                <label for="commercial-registration-number" class="commercial-registration-label form-label" appRequiredField="commercialRegistrationNumber">Commercial Registration Number</label>
                <input type="text" class="commercial-registration-input form-control rounded-4 bg-light" id="commercial-registration-number"
                    formControlName="commercialRegistrationNumber" placeholder="Enter your Commercial Registration Number">
                <div *ngIf="accountInfoForm.get('commercialRegistrationNumber')?.invalid && (accountInfoForm.get('commercialRegistrationNumber')?.dirty || accountInfoForm.get('commercialRegistrationNumber')?.touched)"
                    class="text-danger">
                    <small *ngIf="accountInfoForm.get('commercialRegistrationNumber')?.errors?.['required']">This field is required</small>
                    <small *ngIf="accountInfoForm.get('commercialRegistrationNumber')?.errors?.['custom']">{{
                        accountInfoForm.get('commercialRegistrationNumber')?.errors?.['custom'] }}</small>
                </div>
            </div>

            <div class="mb-3 country-section">
                <label for="country" class="country-label form-label"
                    appRequiredField="CountryRegionIdPrimary">Country</label>
                <div class="dropdown-country">
                    <select class="country-select form-control rounded-4 bg-light" id="country"
                        formControlName="CountryRegionIdPrimary">
                        <option value="" selected disabled>Choose Country</option>
                        <option *ngFor="let country of countries" [value]="country.countryRegionId">
                            {{ country.countryName }}
                        </option>

                    </select>

                </div>
                <div *ngIf="accountInfoForm.get('CountryRegionIdPrimary')?.invalid && (accountInfoForm.get('CountryRegionIdPrimary')?.dirty || accountInfoForm.get('CountryRegionIdPrimary')?.touched)"
                    class="text-danger">
                    <small *ngIf="accountInfoForm.get('CountryRegionIdPrimary')?.errors?.['required']">This field is
                        required</small>
                    <small *ngIf="accountInfoForm.get('CountryRegionIdPrimary')?.errors?.['custom']">{{
                        accountInfoForm.get('CountryRegionIdPrimary')?.errors?.['custom'] }}</small>
                </div>
            </div>



            <!-- <div class="phone-section">
                        <label for="phone-number" class="phone-label form-label" appRequiredField="Mobile">Mobile Number</label>
                        <div class="phone-input form-control rounded-4 bg-light">
                            <select id="country-code" class="custom-select" formControlName="MobileCode">
                            <option *ngFor="let country of countryCodes" [value]="country.code" >
                              {{ country.flag }} {{ country.code }} ({{ country.country }})
                            </option>
                          </select>
                            <input type="tel" id="phone-number" placeholder="Mobile number" formControlName="Mobile" class="phone-number-input">
                        </div>
                        <small *ngIf="accountInfoForm.get('Mobile')?.errors?.['custom']">{{ accountInfoForm.get('Mobile')?.errors?.['custom'] }}</small>
                    </div> -->

            <app-mobile-input [form]="accountInfoForm"></app-mobile-input>


            <div class="text-danger">
                <small *ngIf="accountInfoForm.get('Errors')?.errors?.['custom']">{{
                    accountInfoForm.get('Errors')?.errors?.['custom'] }}</small>
            </div>



            <div class="submition d-flex justify-content-center mt-5">

                <button type="submit" class="submit-btn btn btn-primary">Register</button>
            </div>
        </form>

    </div>
</div>